import { createSelector } from 'reselect';
import { getClubsSelector } from './selector/get-clubs.selector';
import { ClubCategoryView } from './view/club-category.view';

export const ClubCategoriesPresenter = createSelector(
  [getClubsSelector],
  (clubs): ClubCategoryView[] => {
    return clubs
      .flatMap((c) => c.categories)
      .filter(
        (category, index, self) =>
          self.findIndex((c) => c.categoryId === category.categoryId) === index,
      )
      .map(
        (category) =>
          ({
            id: category.id,
            categoryId: category.categoryId,
            name: category.name,
          }) satisfies ClubCategoryView as ClubCategoryView,
      )
      .sort((a, b) => a.name.localeCompare(b.name));
  },
);
